module.exports = __webpack_public_path__ + "media/images/review/ico-crown-3-54a2857d5d86aac604d02bc5232e2f65.svg";